/* Tilipix — mega menus desktop (Kits, Noël) + menu mobile (thème Palo Alto) */
(() => {
  const CLOSE_DELAY = 140;
  const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const instances = new Set();

  function initMega(item) {
    if (item.dataset.tlxReady || item.closest('.js__header__clone')) return;
    const trigger = item.querySelector('[data-tlx-mega-trigger]');
    const panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    item.dataset.tlxReady = '1';
    const backdrop = panel.parentElement.querySelector('[data-tlx-mega-backdrop]');
    const isHashLink = () => (trigger.getAttribute('href') || '#') === '#';
    let timer;

    const api = {};
    const setState = (open) => {
      clearTimeout(timer);
      // Un seul panneau ouvert à la fois (Kits / Noël)
      if (open) {
        instances.forEach((other) => {
          if (other === api) return;
          if (!other.item.isConnected) instances.delete(other);
          else other.closeNow();
        });
      }
      item.classList.toggle('is-open', open);
      panel.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', String(open));
      // Voile partagé : visible tant qu'un panneau est ouvert
      if (backdrop) {
        backdrop.classList.toggle('is-open', !!panel.parentElement.querySelector('[data-tlx-mega-panel].is-open'));
      }
    };
    const open = () => setState(true);
    const close = () => setState(false);
    const closeLater = () => {
      clearTimeout(timer);
      timer = setTimeout(close, CLOSE_DELAY);
    };
    const isInside = (el) => el && (item.contains(el) || panel.contains(el));
    Object.assign(api, { item, closeNow: close });
    instances.add(api);

    item.addEventListener('mouseenter', () => canHover() && open());
    item.addEventListener('mouseleave', () => canHover() && closeLater());
    panel.addEventListener('mouseenter', () => clearTimeout(timer));
    panel.addEventListener('mouseleave', () => canHover() && closeLater());
    if (backdrop) backdrop.addEventListener('click', close);

    // Clic : sur écran tactile, le 1er appui ouvre le panneau, le 2e suit le lien
    trigger.addEventListener('click', (e) => {
      if (!canHover() && !item.classList.contains('is-open')) {
        e.preventDefault();
        open();
        return;
      }
      if (isHashLink()) {
        e.preventDefault();
        if (!canHover()) close();
      }
    });

    // Clavier : flèche bas / espace ouvre et entre dans le panneau, Échap ferme
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault();
        open();
        const first = panel.querySelector('a');
        if (first) first.focus();
      }
    });
    [item, panel].forEach((el) =>
      el.addEventListener('focusout', (e) => {
        if (!isInside(e.relatedTarget)) close();
      })
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        close();
        trigger.focus();
      }
    });
  }

  // Seuil du menu burger : en alignement « centre », le thème réserve à gauche la même
  // largeur que le bloc de droite (liens secondaires + icônes), alors que notre barre est
  // alignée à gauche, collée au logo. Il passe donc en burger bien trop tôt (~1490 px).
  // On recalcule la largeur minimale sans ce doublement, avec une petite marge.
  function fixHeaderThreshold() {
    const h = document.querySelector('header-component:not(.js__header__clone)');
    if (!h) return;
    if (typeof h.getMinWidth !== 'function' || typeof h.checkWidth !== 'function') {
      if (window.customElements) customElements.whenDefined('header-component').then(() => requestAnimationFrame(fixHeaderThreshold));
      return;
    }
    if (h.getAttribute('data-nav-alignment') !== 'center') return;
    const wasCompressed = h.classList.contains('site-header--compress');
    let min = 0;
    h.classList.remove('site-header--compress');
    h.setAttribute('data-nav-alignment', 'right');
    try {
      min = h.getMinWidth();
    } finally {
      h.setAttribute('data-nav-alignment', 'center');
      if (wasCompressed) h.classList.add('site-header--compress');
    }
    if (min > 0) {
      window.minWidth = min + 16;
      h.checkWidth();
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-tlx-mega-item]').forEach(initMega);
    fixHeaderThreshold();
  }

  // Menu mobile : délégation, fonctionne aussi après rechargement de section dans l'éditeur
  if (!window.__tlxMenuBound) {
    window.__tlxMenuBound = true;
    document.addEventListener('click', (e) => {
      const dlg = document.getElementById('TlxMobileMenu');
      if (!dlg) return;
      if (e.target.closest('[data-tlx-menu-open]')) {
        e.preventDefault();
        if (!dlg.open) dlg.showModal();
      } else if (e.target.closest('[data-tlx-menu-close]') || e.target === dlg) {
        dlg.close();
      }
    });
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  // Les polices changent la largeur des liens : on recalcule une fois chargées
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fixHeaderThreshold);
})();
